export default __webpack_public_path__ + "static/media/Mark-5-Suit-01.626ece85.jpg";